import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-footer-wrap" }
const _hoisted_2 = { class: "foot-section-title" }
const _hoisted_3 = { class: "payment-wrap" }
const _hoisted_4 = { class: "company-info-wrap" }

import { ref } from 'vue';
import LicenseFooter from '@/components/LicenseFooter';

export default {
  __name: 'PageFooter',
  setup(__props) {


return (_ctx, _cache) => {
  const _component_van_image = _resolveComponent("van-image")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "divider-line" }, null, -1)),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('footer.payment')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_van_image, {
        class: "payment-img",
        src: require('@/assets/img/common/footer/payment/maya.png')
      }, null, 8, ["src"]),
      _createVNode(_component_van_image, {
        class: "payment-img",
        src: require('@/assets/img/common/footer/payment/grabpay.png')
      }, null, 8, ["src"]),
      _createVNode(_component_van_image, {
        class: "payment-img",
        src: require('@/assets/img/common/footer/payment/gcash.png')
      }, null, 8, ["src"]),
      _createVNode(_component_van_image, {
        class: "payment-img",
        src: require('@/assets/img/common/footer/payment/banking.png')
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('footer.websiteInfo')), 1),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "divider-line" }, null, -1)),
    _createVNode(_unref(LicenseFooter)),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "tabbar-height" }, null, -1))
  ]))
}
}

}